export default __webpack_public_path__ + "static/media/SHOWER-TAB-HOT-MOP.9a0baefd.jpg";